module.exports = __webpack_public_path__ + "66bd10af41c2d5aa5383f98adf787191.svg";